function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function DevelopmentSizeIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M22.2357 19.3071L21.1628 17.6204L14.5366 21.8354L13.4634 20.1479L20.0894 15.9331L19.0164 14.2462L24 14.6304L22.2357 19.3071V19.3071ZM4.98364 14.2462L0 14.6304L1.76428 19.3071L2.83716 17.6204L9.46338 21.8354L10.5366 20.1479L3.91058 15.933L4.98364 14.2462ZM23.73 9.3706L12 16.5767L0.26953 9.37061L12 2.16455L23.73 9.3706ZM12 14.229L19.9087 9.3706L12 4.5122L4.09082 9.3706L12 14.229Z",
    fill: "currentColor"
  }));
}
export function DevelopmentSizeIconSmall(props) {
  return ___EmotionJSX(DevelopmentSizeIcon, _extends({
    size: "small"
  }, props));
}